import { csrfToken, domReady } from "../helpers"

$(document).on("click", ".onboarding-card > a", function () {
  const kind = $(this).data("kind")
  if (kind === "observers") {
    $(this).parent().addClass("complete")
    $.ajax({
      type: "PUT",
      url: `/team/onboarding_components/${kind}`,
      dataType: "json",
      beforeSend(xhr) {
        xhr.setRequestHeader("X-CSRF-Token", csrfToken())
      },
    })
  }
})

$(document).on("click", ".onboarding .form-check.add-existing-member input[type=checkbox]", function () {
  const $res = $(this)
  if ($res.is(":checked")) {
    $res.parent().append(`<input type='hidden' name='existing_members[][email]' value='${$(this).data("email")}' />`)
    if ($res.data("first-name") && $res.data("first-name").length > 0) {
      $res
        .parent()
        .append(`<input type='hidden' name='existing_members[][first_name]' value='${$res.data("first-name")}' />`)
    }
    if ($res.data("last-name") && $res.data("last-name").length > 0) {
      $res
        .parent()
        .append(`<input type='hidden' name='existing_members[][last_name]' value='${$res.data("last-name")}' />`)
    }
    if ($res.data("time-zone") && $res.data("time-zone").length > 0) {
      $res
        .parent()
        .append(`<input type='hidden' name='existing_members[][time_zone]' value='${$res.data("time-zone")}' />`)
    }
  } else {
    $res.parent().find("input[type=hidden]").remove()
  }
})

domReady(function () {
  $(".onboarding a.member-form-add-row").click(function () {
    const $res = $(".onboarding .member-form").first().clone()
    $res.find("input").val("")
    $res.appendTo(".onboarding .member-forms")
    $res.find("input")[0].focus()
  })

  $(".onboarding #options-keep-time-zone").click(function () {
    $(".onboarding .time-zone-selection").hide()
    $(".onboarding .custom-radio.keep-time-zone").addClass("active")
    $(".onboarding .custom-radio.change-time-zone").removeClass("active")
  })
  $(".onboarding #options-change-time-zone").click(function () {
    $(".onboarding .time-zone-selection").show()
    $(".onboarding .custom-radio.keep-time-zone").removeClass("active")
    $(".onboarding .custom-radio.change-time-zone").addClass("active")
  })

  $(".onboarding #options-keep-report-frequency").click(function () {
    $(".onboarding .report-frequency-selection").hide()
    $(".onboarding .custom-radio.keep-report-frequency").addClass("active")
    $(".onboarding .custom-radio.change-report-frequency").removeClass("active")
  })
  $(".onboarding #options-change-report-frequency").click(function () {
    $(".onboarding .report-frequency-selection").show()
    $(".onboarding .custom-radio.keep-report-frequency").removeClass("active")
    $(".onboarding .custom-radio.change-report-frequency").addClass("active")
  })

  $(".onboarding #options-keep-reminder-time").click(function () {
    $(".onboarding .reminder-time-selection").hide()
    $(".onboarding .custom-radio.keep-reminder-time").addClass("active")
    $(".onboarding .custom-radio.change-reminder-time").removeClass("active")
  })
  return $(".onboarding #options-change-reminder-time").click(function () {
    $(".onboarding .reminder-time-selection").show()
    $(".onboarding .custom-radio.keep-reminder-time").removeClass("active")
    $(".onboarding .custom-radio.change-reminder-time").addClass("active")
  })
})
